export default {
  applePay: {
    merchantName: 'Reverb',
    button: 'Check out with Apple Pay',
  },
  addressBook: {
    cancel: 'Cancel',
    row: {
      actions: {
        change: 'Change',
      },
    },
    listView: {
      header: 'Choose Shipping Address',
      submit: 'Use Address',
    },
    createView: {
      header: 'Add a New Shipping Address',
      submit: 'Save & Use Address',
    },
    editView: {
      header: 'Edit Shipping Address',
      submit: 'Save & Use Address',
    },
  },
  authCallout: {
    signUp: {
      prompt: 'Want all the features Reverb has to offer?',
      buttonText: 'Create an account',
    },
    signIn: {
      prompt: 'Already have a Reverb account?',
      buttonText: 'Log in to save time',
    },
  },
  cart: {
    startCheckout: 'Proceed to Checkout',
    guestUserAuthModalText: "Don't have an account?",
    guestUserAuthModalButtonText: 'Continue as Guest',
  },
  combineAndSaveTooltipText: 'Shipping discounts apply when buying multiple qualified items from this shop',
  checkoutProgressBar: {
    shipping: 'Shipping',
    payment: 'Payment',
    confirmation: 'Confirmation',
  },
  loadingIndicator: {
    oneMomentPlease: 'One moment please',
  },
  orderSummary: {
    cannotBeShippedToAddress: 'Sorry, this listing is not available to ship to your location.',
    messageSeller: 'Message Seller',
    soldBy: 'Sold by {{shopName}}',
    shipsFrom: 'Ships from {{location}}',
    shippingCost: '{{amount}} Shipping',
    title: 'Order Summary',
  },
  orderQuantitySelector: {
    label: 'Quantity',
  },
  orderShippingMethodSelector: {
    label: 'Shipping Method',
  },
  paymentLayout: {
    continueOnKlarna: 'Continue on Klarna',
    changeShippingAddress: 'Change',
  },
  paymentMethod: {
    title: 'Payment Method',
    affirm: {
      nextStep: 'You will be redirected to Affirm to set up your payment.',
    },
    klarnaAccount: {
      ca: 'Canadian residents only, 18+. See Canadian payment {{linkOpen}}terms{{linkClose}}. A higher initial payment may be required for some consumers.',
      default: 'You must be 18+ to use this credit offer. Klarna uses soft searches with credit reference agencies. These do not affect your credit rating. Missed payments can affect your ability to use Klarna.',
    },
    billingAddress: 'Billing Address',
  },
  redirectReturnLayout: {
    paymentProcessing: 'Processing...',
  },
  paymentInProgressLayout: {
    title: {
      paymentInProgress: 'Placing your order...',
      paymentProcessing: 'Processing...',
    },
  },
  shippingAddress: 'Shipping Address',
  shippingLayout: {
    continueToPayment: 'Continue',
  },
  creditCardCreateForm: {
    editButton: 'Edit',
    cancelEditButton: 'Cancel',
  },
  creditCardDeleteButton: {
    default: 'Delete Credit Card',
    loading: 'Please wait...',
  },
  creditCardSaveButton: {
    default: 'Continue',
    saving: 'Please wait...',
  },
  contactInfo: {
    firstNameLabel: 'First name',
    lastNameLabel: 'Last name',
    emailLabel: 'Email',
  },
  newShippingAddressForm: {
    contactInfo: {
      title: 'Contact Info',
      subtitle: 'So we can send you a receipt & shipping info',
    },
    address: {
      tooltip: 'Add your phone number to stay informed about your package.',
      phoneLabelText: 'Phone Number',
    },
    saveButton: {
      default: 'Continue',
      saving: 'Please wait...',
    },
    editButton: 'Edit',
    cancelEditButton: 'Cancel',
  },
  billingAddressForm: {
    address: {
      tooltip: 'Add your phone number to stay informed about your package.',
      phoneLabelText: 'Phone Number',
    },
    saveButton: {
      default: 'Save Changes',
      saving: 'Saving...',
    },
    cancel: 'Cancel',
    sameAsShipping: 'Same as shipping address',
  },
  buyItNow: {
    title: 'Buy It Now',
    error: 'Something went wrong. Please try again.',
    applePay: 'Apple Pay',
    notInSameCountry: 'This item is shipping to you from {{sellerCountry}}. You may be required to pay import duties or taxes upon delivery.',
  },
  paypal: {
    error: 'Something went wrong. Please try again.',
  },
  expressCheckout: {
    title: 'Express Checkout',
    separatorText: 'or',
  },
  errors: {
    standardUserExists: 'You already have an account on Reverb. Please log in to complete this order.',
  },
  checkoutLayout: {
    saveAddress: 'Save Address',
    addressSaved: 'Saved',
  },
  creditCardWallet: {
    modalButtonChange: 'Change',
    modalButtonSelect: 'Select a card',
  },
  changePaymentMethod: {
    direct_checkout: {
      message: "Don't want to use a card? {{children}} and choose a different payment method.",
      link: 'Go back to cart',
    },
    klarna_account: {
      message: "Don't want to use Klarna? {{children}} and choose a different payment method.",
      link: 'Go back to cart',
    },
    klarna_pay_later: {
      message: "Don't want to use Klarna? {{children}} and choose a different payment method.",
      link: 'Go back to cart',
    },
    sofort: {
      message: "Don't want to use Sofort? {{children}} and choose a different payment method.",
      link: 'Go back to cart',
    },
    affirm: {
      message: "Don't want to use Affirm? {{children}} and choose a different payment method.",
      link: 'Go back to cart',
    },
  },
  confirmationPage: {
    claimOrderBannerText: 'This email address is associated with an existing Reverb account',
    claimOrderButtonText: 'Sign In to Save Order',
  },
  sofortContinueButton: {
    buttonText: 'Continue on Sofort',
  },
  affirmContinueButton: {
    text: {
      default: 'Check Out with Affirm',
      loading: 'Please wait...',
    },
  },
  cardContinueButton: {
    text: {
      default: 'Place Order',
      loading: 'Please wait...',
    },
  },
  termsAndConditions: "By continuing, you agree to Reverb's {{termsLinkOpen}}Terms{{termsLinkClose}} and {{privacyPolicyLinkOpen}}Privacy Policy{{privacyPolicyLinkClose}}.",
  postPurchaseShopNudge: {
    title: 'Add {{shop}} to your Favorites',
    subtitle: "You'll be the first to know about deals, new listings, and special offers.",
  },
};
